<script lang="ts">
	import GithubIconGreen from 'assets/svg/github.svg?component';
	// import Dropdown from './Dropdown/Dropdown.svelte';

	export let dark;
	export let url;
	// eslint-disable-next-line svelte/valid-compile
	export let getData;

	const tabs = ['CORE ONLY' /*'ALL REPOS', 'SOURCES', 'FORKS'*/];
	let active = 0;

	// const getType = () => {
	// 	switch (active) {
	// 		case 0:
	// 			return 'core';
	// 		/* case 1: return 'all';
  //           case 2: return 'forks';*/
	// 	}
	// };
</script>

<div class="github-section-header">
	{#each tabs as tab, i}
		<button
			class="github-section-header-tab"
			class:dark
			class:active={i === active}
			on:click={async () => {
				// active = i;
				// await getData(getType());
			}}>{tab}</button
		>
	{/each}
	<a href={url} target="_blank" class="github-button" rel="noopener noreferrer" class:dark>
		<GithubIconGreen class="social-icon-green" width="12" height="16" />
		<p class="text">Github</p>
	</a>
	<!-- <Dropdown {dark} {getData} /> -->
</div>

<style lang="scss">
	@import 'githubSecionHeader';
	@import '../githubSection';
</style>
